import _toConsumableArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import FormHelperText from '@material-ui/core/FormHelperText';
import ConnectedFormField from './ConnectedFormField';
import fieldsLogic from '../logic/fieldsLogic';
import Icon from '../../../../core/Icon';
import Utils from '../../../../utils';
import RepeatingAddButton from './RepeatingAddButton';

var FormRepeating = function FormRepeating(props) {
  var fieldId = props.fieldId,
      items = props.items,
      dispatch = props.dispatch;
  var caption = props.caption,
      collapsed = props.collapsed,
      error = props.error,
      readonly = props.readonly,
      addBtnContent = props.addBtnContent;
  var values = items && items.map(function (i) {
    return i.value;
  });

  var onToggle = function onToggle() {
    fieldsLogic.onMetaPropChanged(fieldId, 'collapsed', !collapsed, dispatch);
  };

  var removeItem = function removeItem(value) {
    var newValues = _toConsumableArray(values);

    newValues.splice(newValues.indexOf(value), 1);
    fieldsLogic.onRepeatingChange(fieldId, newValues, dispatch);
  };

  return React.createElement(Grid, {
    container: true,
    direction: "column",
    justify: "flex-start",
    alignItems: "stretch",
    style: {
      borderLeft: '3px solid #E0E5EB',
      flexWrap: 'nowrap'
    }
  }, React.createElement(Grid, {
    item: true,
    container: true,
    direction: "row",
    style: {
      backgroundColor: '#E0E5EB',
      paddingTop: 4,
      paddingBottom: 4
    }
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(Icon, {
    style: {
      color: 'black'
    },
    type: collapsed ? 'menu-right' : 'menu-down',
    onClick: onToggle,
    hoverable: true,
    buttonSize: "small"
  })), React.createElement(Grid, {
    item: true
  }, React.createElement(Typography, {
    style: {
      color: 'black'
    }
  }, caption))), !collapsed && items && items.map(function (item) {
    var value = item.value,
        container = item.container;
    var index = items.indexOf(item);
    var backgroundColor = index % 2 === 0 ? 'white' : '#eee';
    if (!container) return null;
    return React.createElement(Grid, {
      style: {
        backgroundColor: backgroundColor
      },
      key: value
    }, container.rows && container.rows.map(function (row, rowIdx) {
      return React.createElement(Grid, {
        item: true,
        container: true,
        direction: "row",
        key: row.id || rowIdx
      }, row.fields.map(function (field) {
        return React.createElement(Grid, {
          item: true,
          xs: field.size,
          key: field.id,
          className: "form-group"
        }, React.createElement(ConnectedFormField, {
          fieldId: field.id
        }));
      }));
    }), !readonly && React.createElement(Grid, {
      item: true,
      direction: "column",
      container: true,
      alignItems: "flex-end"
    }, React.createElement(Grid, {
      item: true
    }, React.createElement(Icon, {
      hoverable: true,
      buttonSize: "medium",
      buttonProps: {
        fontSize: 16
      },
      type: "delete",
      onClick: function onClick() {
        return removeItem(value);
      }
    }))));
  }), React.createElement(Grid, {
    item: true,
    direction: "column",
    container: true,
    alignItems: "flex-end"
  }, !collapsed && React.createElement(Grid, {
    item: true,
    style: {
      padding: 4
    }
  }, React.createElement(RepeatingAddButton, {
    fieldId: fieldId,
    dispatch: dispatch,
    disableAddButton: readonly,
    addBtnContent: addBtnContent,
    items: items
  })), React.createElement(Grid, {
    item: true
  }, React.createElement(FormHelperText, {
    error: !!error,
    margin: "dense"
  }, error || ' '))));
};

export default React.memo(FormRepeating, function (prevProps, nextProps) {
  return Utils.deepEqual(prevProps, nextProps);
});